import Alpine from 'alpinejs'

import loginFormApp from './login.js'
import logoutApp from './logout.js'
import registerApp from './register.js'

export function registerAuthComponents() {
  Alpine.data("loginFormApp", loginFormApp);
  Alpine.data("logoutApp", logoutApp);
  Alpine.data("registerApp", registerApp);
}
